module.exports = __webpack_public_path__ + "img/zh.54f9b2ed.png";